import './Maintenance.css';

import {
  logPageActionToNewRelic,
  logPageActionToSmartlook,
  PAGE_ACTION,
} from '../../utils/util';

import {Header, Card} from '@deere/ux.uxframe-react';
import React from 'react';

const validateDownTime = (downTime) => {
  const downTimeFormat = new RegExp(
    '^0?([0-9][0-2]?):[0-5][0-9][ ](am|pm) to 0?([0-9][0-2]?):[0-5][0-9][ ](am|pm)$'
  );
  return downTimeFormat.test(downTime);
};

const Maintenance = (props) => {
  let prodDownMsg = '';
  if (!validateDownTime(props.data_time)) {
    prodDownMsg = 'for scheduled maintenance.Please try after sometime';
  } else {
    prodDownMsg = 'from ' + props.data_time + ' for scheduled maintenance';
  }
  React.useEffect(() => {
    logPageActionToSmartlook(PAGE_ACTION.MAINTENANCE_PAGE);
    logPageActionToNewRelic(PAGE_ACTION.MAINTENANCE_PAGE, {});
  }, []);

  return (
    <div>
      <div id="CustomHeader">
        <Header
          logoLink="#"
          pageHeading={null}
          pageHeadingLink="#"
          search={false}
          skipLink="app"
          variant="uxf-header-jdf"
          navbar={false}
        ></Header>
      </div>
      <div className="c-downPrd-msg">
        <Card
          style={{
            height: '200pt',
          }}
          className="uxf-card-product mb-4"
        >
          <Card.Body className="uxf-card-body-table">
            <div className="maintenance-msg">
              <svg
                focusable="false"
                aria-hidden="true"
                fill="#666666"
                xmlns="http://www.w3.org/2000/svg"
                width="38.56"
                height="38.33"
                viewBox="0 0 24 24"
              >
                <path fill="none" d="M0 0h24v24H0z"></path>
                <path d="M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z"></path>
              </svg>
              <div className="maintenance-header">Scheduled Maintenance</div>
              <br />
              <div className="maintenance-body">
                MyFinancial is down {prodDownMsg.trim()}.<br />
                <br />
                Thanks for your patience.
              </div>
            </div>
          </Card.Body>
        </Card>
      </div>
    </div>
  );
};

export default Maintenance;
